<template>
<div class="container-fluid">
        <div id="form_inscription">
            <div class="row">
                    <div class="col-md-12" style="clear:both; width:100%; position: fixed; margin-top: 15px; z-index:999;" id="test">
                        <a class="btn btn-lg btn-default pull-left text-bold" id="back_btn" :href="url_back"> <i class="fa fa-lg fa-angle-double-left"></i> volver </a>
                        <button class="btn btn-lg btn-primary pull-right text-bold" style="margin-left:5px;" id="btn_save_inscription" @click="_onSave"><i class="fa fa-lg fa-save"></i> guardar </button>
                    </div>
            </div>

            <div class="row">
                <div class="col-md-6 offset-3" style="padding:15px; background-color: #FFF; margin-top: 20px;">
                    <inscription-steps ref="inscriptionForm" v-if="event"
                        :churchs="churchs"
                        :event="event"
                        :url_inscription_line="url_inscription_line"
                        :logged_user="logged_user"
                    ></inscription-steps>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

// import Datepicker from "vuejs-datepicker/dist/vuejs-datepicker.esm.js";
// import {es} from 'vuejs-datepicker/dist/locale';
import Utils from './Utils';

export default {

    props : ['url_inscription_line','event_id','url_back','line_id','inscription_id','logged_user'],

    data : function()
    {
        return {
            churchs : [],
            event   : null,
        }
    },

    created(){

    },

      // components : {
      //    'inscription-steps' : InscriptionSteps
      // },

      mounted : function()
      {         
         axios.all([
                axios.get('/api/event/'+this.event_id),
                axios.get('/api/church')
         ]).then(axios.spread(function(event, churchs){
            this.event =  event.data.data;
            this.churchs = churchs.data.data;

            this.$nextTick(()=>{
                this.$refs.inscriptionForm.context = 'inscription';
                this.$refs.inscriptionForm.$data.inscription_id = this.inscription_id;
                if (!Utils.isEmpty(this.line_id))
                    this.$refs.inscriptionForm.load(this.line_id);
            });
        }.bind(this)).bind(this))
        .catch(function(error){
            debugger;
            alert('ha ocurrido un error al cargar los datos');
            this.loading = false;
        }.bind(this));             
        /*
         this.$refs.inscriptionForm.$data.line_id = null;
            this.$refs.inscriptionForm._reset();
         */
      },

      methods : {

        _onSave : function()
        {
            this.$refs.inscriptionForm.saveInscription(function(error, result){
                if (error)
                {
                    alert('error: '+error);
                }
                else
                {
                    alert('inscripción guardada correctamente');
                }
            });
        }
    }
}
</script>